<template>
  <b-card-code title="Lista de Horarios" no-body v-if="!isFetching">
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <b-form-group
          label-align-sm="left"
          label-cols-sm="2"
          label-for="sortBySelect">
          <h5>Ordenar</h5>
          <b-input-group>
            <b-form-select
              id="sortBySelect"
              v-model="sortBy"
              :options="sortOptions">
              <template #first>
                <option value="">Ninguno</option>
              </template>
            </b-form-select>
            <b-form-select v-model="sortDesc" :disabled="!sortBy">
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>

        <b-form-group v-if="$can('create', 'AddSchedules')">
          <h5>Añadir</h5>
          <b-input-group>
            <b-button variant="primary" to="/schedules/create" class="btn-icon">
              <feather-icon icon="PlusCircleIcon" /> Nuevo Horario
            </b-button>
          </b-input-group>
        </b-form-group>
      </div>
    </b-card-body>

    <b-table
      borderless
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :current-page="currentPage"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection">
      <template #cell(Modify)="data" v-if="$can('edit', 'EditSchedules')">
        <b-button
          variant="flat-primary"
          :to="{
            name: 'edit-schedules',
            params: { id: data.item.pkid_timetable },
          }"
          class="btn-icon"
          size="sm">
          <feather-icon icon="EditIcon" size="24" />
        </b-button>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
        label="Por página"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1">
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions" />
      </b-form-group>
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@/libs/axios";
import moment from "moment";

export default {
  components: {
    BCardCode,
    ToastificationContent,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  methods: {},
  data() {
    return {
      isFetching: true,
      perPage: 50,
      pageOptions: [50, 100, 200, 500],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      pkid_timetable: [],
      fields: [
        { class: "colModify", key: "Modify", label: "" },
        { key: "pkid_timetable", label: "ID Horario", sortable: true },
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        {
          key: "datetime_start",
          label: "Fecha Inicio",
          sortable: true,
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        {
          key: "datetime_end",
          label: "Fecha Final",
          sortable: true,
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        {
          key: "timestamp_modification",
          label: "Fecha Modificación",
          sortable: true,
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        {
          key: "timestamp_creation",
          label: "Fecha Creación",
          sortable: true,
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { class: "colModify1", key: "Modify1", label: "" },
      ],
      items: [],
    };
  },

  //Funcion para cargar los horarios
  async created() {
    await axios
      .get("/timetable")
      .then((results) => {
        this.items = results.data;
        this.totalRows = this.items.length;
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      });

    this.isFetching = false;
  },

  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0);
    }
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
.colStyle {
  font-size: small;
}

.colModify {
  width: 0px;
}
</style>
